import { GroupsByCategories } from 'components/context/types';
import * as React from 'react';
import { useState } from 'react';
import t from 'utils/translations';
import { SettingsMenu } from 'components/pages/categorypage/CategoryPage';
import { Popover } from 'antd';
import DeleteCategoryModal from 'components/pages/grouplistpage/actionmenu/DeleteCategoryModal';
import RenameGroupOrCategoryModal from 'components/pages/grouplistpage/actionmenu/RenameGroupOrCategoryModal';
import CreateGroupModal from 'components/pages/grouppage/CreateGroupModal';

export interface CategoryActionMenuProps {
    afterActionsFunction: () => void;
    groupsByCategories: GroupsByCategories[];
    id: string;
    name: string;
    numberOfGroupsInCategory?: number;
    activatingElement: React.ReactNode;
    navigateAfterDeletion: () => void;
}

export default function CategoryActionMenu({
    afterActionsFunction,
    groupsByCategories,
    id,
    name,
    numberOfGroupsInCategory,
    activatingElement,
    navigateAfterDeletion
}: CategoryActionMenuProps) {
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [isRenameModalVisible, setIsRenameModalVisible] = useState(false);
    const [isCreateGroupModalVisible, setIsCreateGroupModalVisible] = useState(
        false
    );

    function PopOverContent() {
        return (
            <SettingsMenu>
                <li
                    key={'CREATE_SUB_GROUP'}
                    onClick={() => setIsCreateGroupModalVisible(true)}
                >
                    {t('CREATE_SUB_GROUP')}
                </li>
                <li
                    key={'RENAME_GROUP'}
                    onClick={() => {
                        setIsRenameModalVisible(true);
                    }}
                >
                    {t('RENAME_GROUP')}
                </li>
                <li
                    key={'DELETE_GROUP'}
                    onClick={() => setIsDeleteModalVisible(true)}
                >
                    {t('DELETE_GROUP')}
                </li>
            </SettingsMenu>
        );
    }
    return (
        <>
            <Popover
                content={<PopOverContent />}
                placement={'bottomRight'}
                trigger="click"
                overlayStyle={{ zIndex: 999 }}
            >
                {activatingElement}
            </Popover>

            <DeleteCategoryModal
                afterSuccess={() => {
                    setIsDeleteModalVisible(false);
                    afterActionsFunction();
                    if (navigateAfterDeletion) {
                        navigateAfterDeletion();
                    }
                }}
                categoryId={id}
                closeModal={() => {
                    setIsDeleteModalVisible(false);
                }}
                name={name}
                numberOfGroupsInCategory={numberOfGroupsInCategory || 0}
                visible={isDeleteModalVisible}
            />
            <RenameGroupOrCategoryModal
                afterSuccess={() => {
                    setIsRenameModalVisible(false);
                    afterActionsFunction();
                }}
                closeModal={() => {
                    setIsRenameModalVisible(false);
                }}
                id={id}
                initialName={name}
                isCategory={true}
                visible={isRenameModalVisible}
            />
            <CreateGroupModal
                afterSuccess={() => {
                    setIsCreateGroupModalVisible(false);
                    afterActionsFunction();
                }}
                categories={groupsByCategories.map(category => ({
                    categoryId: category.categoryId,
                    categoryName: category.categoryName
                }))}
                closeModal={() => setIsCreateGroupModalVisible(false)}
                preSelectedCategoryId={id}
                visible={isCreateGroupModalVisible}
            />
        </>
    );
}
